import { useNavigate } from 'react-router-dom';
import './CardWithoutBottomHeader.scss';
import { FC, useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/app/hooks';
import { setSelectedLibraryId, setSelectedSubjectId } from '../../redux/slices/dashboardSlice';
import images from '../../assets/images';
import { Tooltip } from '@mui/material';

interface PropsType {
  image: string|null;
  title: string;
  imageHeight: string;
  imageWidth: string;
  navigateLocation: string;
  libraryId?: string;
  subId?: string;
  keyValue: string;
  sessionActive?: boolean;
  tabName?: string;
  unreadMsgCount?:number;
  backGroundColor?: string;
  active ? : boolean
}
const CardWithoutBottomHeader: FC<PropsType> = ({ keyValue, image, title, imageHeight, imageWidth, navigateLocation, libraryId, subId, sessionActive, tabName, unreadMsgCount, backGroundColor, active }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { redDotImage } = images;
  const [isOverflow, setIsOverflow] = useState(false);
  const subjectNameRef = useRef<HTMLDivElement | null>(null);
  const baseUrl = process.env.REACT_APP_FRONTEND_URL;
  const virtualProgramDetails = useAppSelector((state) => state?.virtualClassRoom?.virtualProgramDetails)
  const virtualProgramName = virtualProgramDetails?.vpName
  const role = useAppSelector((state) => state.auth.role);


  //To check the container is overflow
  const checkOverflow = () => {
    if (subjectNameRef.current) {
      setIsOverflow(subjectNameRef.current.scrollWidth > subjectNameRef.current.clientWidth);
    }
  }

  //To check overflow in resize 
  useEffect(() => {
    if (title) {
          checkOverflow();
  }
    window.addEventListener('resize', checkOverflow);

    return () => {
      window.removeEventListener('resize', checkOverflow);
    };
  }, [title]);

  const onClickCard = () => {
    if (libraryId) {
      dispatch(setSelectedLibraryId({ selectedLibraryId: libraryId }));
    }
    if (subId) {
      dispatch(setSelectedSubjectId({ selectedSubjectId: subId }));
    }
    console.log(title,image,backGroundColor,role, "navigation", navigateLocation)
    navigate(navigateLocation, { state: { title, imageSrc: image, backGroundColor, role } });
  }
  
  return (
    <div className={subId ? 'cardWithoutBottomHeaderMainContainer' : 'cardWithoutBottomHeaderMainContainer mylibraryWithoutCardMobile'} data-key={keyValue} onClick={() => onClickCard()} key={keyValue}>
      <div className='cardTopContainer'>
        {(tabName && tabName === "LiveClass" && sessionActive) && <img src={redDotImage} className='redDotStyle' alt='redDotImage'/>}
        {( active) && <img src={redDotImage} className='redDotStyle' alt='redDotImage'/>}
        {(tabName === "Chats" && unreadMsgCount !== undefined && unreadMsgCount > 0) && (<div  className={unreadMsgCount > 0 ?'unreadCountStyle':'unreadCountStyleDisable'}>{unreadMsgCount}</div>)}
        {(image) ? (
          <img
            src={ image }
            alt='cardImage'
            className='cardImageStyle'
            style={{
              width: imageWidth,
              height: imageHeight,
              borderRadius:(imageWidth === '100%' || imageHeight === '100%') ? '20px': '' 
            }}
          /> ) : (
            <div style={{
              width: imageWidth,
              height: imageHeight,
              borderRadius:(imageWidth === '100%' || imageHeight === '100%') ? '20px': '',
              backgroundColor: backGroundColor,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}>
              <span className='titleStyle'>{ title?.charAt(0).toUpperCase() }</span>
            </div>
          )}
      </div>
      <Tooltip
        title={title}
        disableHoverListener={!isOverflow}
        placement="top">
        <div className='cardTitleContainer' ref={subjectNameRef}
          onMouseEnter={checkOverflow}>{title}</div>
      </Tooltip>
    </div>
  )
}

export default CardWithoutBottomHeader;
